/**
 * 资格认证详情
 */
import { Toast } from 'antd-mobile';
import fetch from '@/utils/fetch';
import * as API from '@/commons/http-api';

export default {
  namespace: 'knowLedgeAuthDetail',
  state: {
    title: '', // 页面标题
    tipsContent: [], // 说明内容
    authContent: [], // 认证说明内容
    stydyList: [], // 学习认证课程列表
    isExam: '', // 认证状态
    userName: '', // 用户名
    credentialsDesc: '', // 认证后的证书说明
  },
  reducers: {
    setTitle(state, action) {
      return {
        ...state,
        title: action.payload,
      };
    },
    setTipsContent(state, action) {
      const tipsContent = action.payload.replace(/\n|\r/g, ';').split(';');
      return {
        ...state,
        tipsContent,
      };
    },
    setAuthContent(state, action) {
      const authContent = action.payload.replace(/\n|\r/g, ';').split(';');
      return {
        ...state,
        authContent,
      };
    },
    setStudyList(state, action) {
      return {
        ...state,
        stydyList: action.payload,
      };
    },
    setIsExam(state, action) {
      return {
        ...state,
        isExam: action.payload,
      };
    },
    setCredentialsDesc(state, action) {
      return {
        ...state,
        credentialsDesc: action.payload,
      };
    },
    setUserName(state, action) {
      return {
        ...state,
        userName: action.payload,
      };
    },
    resetState() {
      return {
        title: '', // 页面标题
        tipsContent: [], // 说明内容
        authContent: [], // 认证说明内容
        stydyList: [], // 学习认证课程列表
        isExam: '', // 认证状态
        userName: '', // 用户名
      };
    },
  },
  effects: {
    *getAuthDetailInfo(action, { put }) {
      Toast.loading('加载中...', 0);
      const { id } = action.payload;
      let params = { uuid: id };
      const res = yield fetch.get(API.KNOLEDGE_DETAIL_INFO, params);
      if (!res.errorType) {
        const {
          certificationName,
          certificationDesc,
          certificationAuthDesc,
          certificationCourses,
          isExam,
          userName,
          credentialsDesc,
        } = res.data;
        yield put({
          type: 'setTitle',
          payload: certificationName,
        });
        yield put({
          type: 'setTipsContent',
          payload: certificationDesc,
        });
        yield put({
          type: 'setAuthContent',
          payload: certificationAuthDesc,
        });
        yield put({
          type: 'setStudyList',
          payload: certificationCourses,
        });
        yield put({
          type: 'setIsExam',
          payload: isExam,
        });
        yield put({
          type: 'setUserName',
          payload: userName,
        });
        yield put({
          type: 'setCredentialsDesc',
          payload: credentialsDesc,
        });
        Toast.hide();
      } else {
        Toast.fail(res.message);
      }
    },
  },
};
